module.exports = __webpack_public_path__ + "media/images/blue-inbox-0002ad744e1e2dc94208267501256a95.jpg";